import * as THREE from "three";
import getPosInfo from "./getPosInfo";
import getMaterialTexture from "./getMaterialTexture";
import subtractMeshes from "./subtractMeshes";
import joinMeshes from "./joinMeshes";

const addStripe = async (el, settings, settingImages) => {

    const bigPlateWidth = el.size.width / 100;
    const bigPlateDepth = el.size.length / 100;

    const smallPlateWidth =
        bigPlateWidth - (parseFloat(el.thickness) * 2) / 100;
    const smallPlateDepth =
        bigPlateDepth - (parseFloat(el.thickness) * 2) / 100;

    const plateHeight =
        (parseFloat(el.size.height) + parseFloat(el.size.depth)) / 100;

    const bigPlateGeometry = new THREE.BoxGeometry(
        bigPlateWidth,
        plateHeight,
        bigPlateDepth
    );

    const smallPlateGeometry = new THREE.BoxGeometry(
        smallPlateWidth,
        plateHeight,
        smallPlateDepth
    );

    const bigPlateFill = new THREE.Mesh(
        bigPlateGeometry,
        new THREE.MeshStandardMaterial({ color: 0xff0000 })
    );

    const smallPlateFill = new THREE.Mesh(
        smallPlateGeometry,
        new THREE.MeshStandardMaterial({ color: 0x00ff00 })
    );

    const boxMaxboxMinSubtractMesh = await subtractMeshes(bigPlateFill, smallPlateFill);

    boxMaxboxMinSubtractMesh.material = getMaterialTexture(
        el.texture,
        false,
        true
    );


    const stripeBbox = getPosInfo(boxMaxboxMinSubtractMesh)
    boxMaxboxMinSubtractMesh.position.y += stripeBbox.ySize / 2;
    boxMaxboxMinSubtractMesh.updateMatrix();

    if (el.size && el.size.depth) {
        boxMaxboxMinSubtractMesh.position.y -= +el.size.depth / 100;
        boxMaxboxMinSubtractMesh.updateMatrix();
    }
    return boxMaxboxMinSubtractMesh;

}
export default addStripe;
